"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
_Object$defineProperty(exports, "defaultTheme", {
  enumerable: true,
  get: function get() {
    return _defaultTheme.default;
  }
});
_Object$defineProperty(exports, "evolutionTheme", {
  enumerable: true,
  get: function get() {
    return _Evolution.default;
  }
});
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _defaultTheme = _interopRequireDefault(require("./defaultTheme"));
var _Evolution = _interopRequireDefault(require("./Evolution"));
function cov_13q7aoimg() {
  var path = "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/ThemeMapper/lib/index.js";
  var hash = "7715e781db6607ca053132543558b48e06797ece";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/ThemeMapper/lib/index.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 27
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "2": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 37
        }
      },
      "3": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 14
        }
      },
      "4": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 17,
          column: 48
        }
      },
      "5": {
        start: {
          line: 20,
          column: 13
        },
        end: {
          line: 20,
          column: 32
        }
      },
      "6": {
        start: {
          line: 21,
          column: 15
        },
        end: {
          line: 21,
          column: 70
        }
      },
      "7": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 212,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 27
          },
          end: {
            line: 7,
            column: 28
          }
        },
        loc: {
          start: {
            line: 7,
            column: 44
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 15
          },
          end: {
            line: 16,
            column: 16
          }
        },
        loc: {
          start: {
            line: 16,
            column: 37
          },
          end: {
            line: 213,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 15
          },
          end: {
            line: 21,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 15
          },
          end: {
            line: 21,
            column: 39
          }
        }, {
          start: {
            line: 21,
            column: 43
          },
          end: {
            line: 21,
            column: 70
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 26,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 26,
            column: 28
          }
        }, {
          start: {
            line: 26,
            column: 32
          },
          end: {
            line: 26,
            column: 45
          }
        }],
        line: 26
      },
      "2": {
        loc: {
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 130,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 129,
            column: 12
          },
          end: {
            line: 129,
            column: 32
          }
        }, {
          start: {
            line: 130,
            column: 12
          },
          end: {
            line: 130,
            column: 31
          }
        }],
        line: 126
      },
      "3": {
        loc: {
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 128,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 126,
            column: 45
          }
        }, {
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 127,
            column: 28
          }
        }, {
          start: {
            line: 128,
            column: 8
          },
          end: {
            line: 128,
            column: 54
          }
        }],
        line: 126
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7715e781db6607ca053132543558b48e06797ece"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_13q7aoimg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_13q7aoimg();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
cov_13q7aoimg().s[0]++;
var parseTS15Variables = function parseTS15Variables(ts15Variables) {
  cov_13q7aoimg().f[0]++;
  cov_13q7aoimg().s[1]++;
  try {
    cov_13q7aoimg().s[2]++;
    return JSON.parse(ts15Variables);
  } catch (_e) {
    cov_13q7aoimg().s[3]++;
    return {};
  }
};

// eslint-disable-next-line func-names
function _default(themeConfig) {
  cov_13q7aoimg().f[1]++;
  var theme = (cov_13q7aoimg().s[4]++, (0, _merge.default)(_defaultTheme.default, themeConfig));
  // hack to know if we are on ie.
  /* MSIE used to detect old browsers and Trident used to newer ones */
  var ua = (cov_13q7aoimg().s[5]++, navigator.userAgent);
  var isIE = (cov_13q7aoimg().s[6]++, (cov_13q7aoimg().b[0][0]++, ua.indexOf('MSIE ') > -1) || (cov_13q7aoimg().b[0][1]++, ua.indexOf('Trident/') > -1));
  cov_13q7aoimg().s[7]++;
  return _objectSpread(_objectSpread(_objectSpread({}, theme), parseTS15Variables(themeConfig === null || themeConfig === void 0 ? void 0 : themeConfig.ts15Variables)), {}, {
    name: (cov_13q7aoimg().b[1][0]++, themeConfig === null || themeConfig === void 0 ? void 0 : themeConfig.theme) || (cov_13q7aoimg().b[1][1]++, 'EQUILIBRIUM'),
    // @gravity/activity-indicator
    activityIndicator: {
      color: theme.textColor
    },
    // @gravity/button
    button: {
      textColor: theme.buttonTextColor,
      backgroundColor: theme.buttonBgColorTop,
      borderRadius: theme.buttonBorderRadius,
      textSize: undefined
    },
    // @gravity/calendar
    calendar: {
      indicatorBgColor: theme.boxTitleBgTop,
      indicatorTextColor: theme.boxTitleTextColor,
      smallDayHeaderBgColor: theme.advantageColor,
      smallDayHeaderTextColor: theme.advantageTextColor,
      selectedDayBgColor: theme.boxBgColor,
      disabledDayBgColor: theme.innerBoxBgColor,
      detailedDayBgColor: theme.innerBoxBgColor,
      borderColor: theme.innerBoxBgColor,
      titleColor: theme.textColor,
      miniCalendarBgColor: theme.boxBgColor,
      miniCalendarTextColor: theme.textColor,
      miniCalendarDayTextColor: theme.textColor,
      miniCalendarMonthBgColor: theme.buttonBgColorTop,
      miniCalendarMonthTextColor: theme.buttonTextColor,
      miniCalencarDatePickerTextColor: theme.textColor,
      NONE: undefined,
      LIMITED: undefined,
      GOOD: undefined
    },
    // @gravity/card
    card: {
      backgroundColor: theme.contentBgColor
    },
    // @gravity/collapsiblePanel
    collapsiblePanel: {
      borderColor: theme.innerBoxBgColor,
      headerBgColor: theme.boxTitleBgTop,
      headerTextColor: theme.boxTitleTextColor,
      bodyBgColor: theme.boxTitleBgTop,
      bodyTextColor: theme.textColor
    },
    // @gravity/date-picker
    datePicker: {
      borderColor: theme.innerBoxBgColor,
      bodyBgColor: theme.boxBgColor
    },
    // @gravity/empty-state
    emptyState: {
      mediaColor: theme.textColor,
      titleColor: theme.textColor,
      textColor: theme.textColor
    },
    // @gravity/event-calendar
    eventCalendar: {
      detailedObjectBgColor: theme.boxBgColor,
      textColor: theme.productNameTextColor,
      highlightColor: theme.boxBgColor,
      highlightTextColor: theme.linkTextColor
    },
    // @gravity/film-strip
    filmStrip: {
      iconBackgroundColor: theme.boxBgColor,
      iconColor: theme.boxTitleTextColor
    },
    // @gravity/heading
    heading: {
      textColor: theme.textColor
    },
    // @gravity/icon
    icon: {
      color: theme.textColor
    },
    // @gravity/input
    input: {
      color: theme.errorColor,
      backgroundColor: theme.inputBgColor
    },
    // @gravity/link
    link: {
      color: theme.linkTextColor
    },
    // @gravity/tabs
    tabs: {
      textColor: theme.boxTitleBgTop,
      blockTextColor: theme.boxTitleTextColor
    },
    // @gravity/text-preview
    textPreview: {
      textColor: theme.textColor
    },
    // @gravity/language-selector
    languageSelector: {
      textColor: theme.headerTextColor,
      // to avoid having a transparent value for the background of language selector, if  the
      // headerBgColor is transparent try to set messageBgColor if exists
      backgroundColor: (cov_13q7aoimg().b[3][0]++, theme.headerBgColor === 'transparent') && (cov_13q7aoimg().b[3][1]++, theme.messageBgColor) && (cov_13q7aoimg().b[3][2]++, theme.headerTextColor !== theme.messageBgColor) ? (cov_13q7aoimg().b[2][0]++, theme.messageBgColor) : (cov_13q7aoimg().b[2][1]++, theme.headerBgColor),
      borderColor: theme.innerBoxBgColor
    },
    // @gravity/ts-header
    tsHeader: {
      backgroundColor: theme.headerBgColor,
      textColor: theme.headerTextColor,
      backgroundImage: theme.headerBgImage,
      mobile: {
        logo: theme.headerMobileLogoUrl,
        logoHeight: theme.headerLogoHeight,
        logoWidth: theme.headerMobileLogoWidth,
        backgroundImage: theme.headerMobileLogo
      }
    },
    // @gravity/section
    section: {
      backgroundColor: theme.innerBoxBgColor
    },
    // @gravity/catalog
    catalog: {
      backgroundColor: theme.bodyBgColor
    },
    // @gravity/productList
    productList: {
      backgroundColor: theme.bodyBgColor,
      contentBgColor: theme.contentBgColor
    },
    // business advantage concept
    advantage: {
      backgroundColor: theme.advantageColor,
      textColor: theme.advantageTextColor
    },
    // @gravity/input-text-filter
    inputTextFilter: {
      innerColor: theme.headerBgColor
    },
    // @gravity/list-filter
    listFilter: {
      listColor: theme.innerBoxBgColor
    },
    // @gravity/multidropdown
    multiDropdown: {
      backgroundColor: theme.buttonBgColorTop,
      colorText: theme.altBoxTitleBgTop
    },
    //  @gravity/product
    product: {
      nameTextColor: theme.productNameTextColor,
      borderColor: theme.innerBoxBgColor,
      stickerBorderColor: theme.innerBoxBgColor,
      descriptionColor: theme.altBoxTitleBgTop,
      fillSvg: theme.buttonBgColorTop,
      cardBgColor: null,
      cardPadding: null,
      cardMargin: null
    },
    // @gravity/quantity-field
    quantityField: {
      minusColor: theme.buttonBgColorTop,
      minusBgColor: theme.buttonTextColor,
      plusColor: theme.buttonTextColor,
      plusBgColor: theme.buttonBgColorTop
    },
    // @gravity/view-selector
    viewSelector: {
      buttonBgColor: theme.bodyBgColor,
      buttonBorderRadius: theme.buttonBorderRadius,
      selectedButtonBgColor: theme.buttonBgColorTop,
      iconColor: theme.textColor
    },
    // technical information on the browser
    browser: {
      isIE: isIE
    },
    // global value
    textColor: theme.textColor,
    backgroundImage: theme.contentBgImage,
    backgroundColor: theme.contentBgColor,
    faviconUrl: theme.faviconUrl,
    // font values that contains isGlobal, family and provider
    font: theme.font
  });
}